import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/sidebar";
import { twJoin } from "tailwind-merge";
import { useCurrentUser } from "../lib/hooks/useCurrentUser";

const MainLayout = () => {
  const currentUser = useCurrentUser();

  return (
    <main
      className={twJoin(
        "min-h-full h-full flex text-sm overflow-hidden w-screen",
        // inter.className,
      )}
    >
      <Sidebar
        permissions={currentUser?.permissions || []}
        oidcRoles={currentUser?.oidcRoles || []}
      />
      <main
        className="flex-grow border-l border-solid border-neutral-300 bg-neutral-200"
        role="main"
      >
        <Outlet />
      </main>
    </main>
  );
};

export { MainLayout };
